import React from "react";
import { LogOut } from "lucide-react";
import { useScan } from "../contexts/ScanContext";
import { useNavigate } from "react-router-dom";

const LogoutButton = () => {
  const { logout } = useScan();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <button
      onClick={handleLogout}
      className="flex items-center gap-2 text-gray-600 hover:text-gray-900 transition-colors"
    >
      <LogOut className="w-4 h-4" />
      <span>Logout</span>
    </button>
  );
};

export default LogoutButton; 